import React, {Component} from 'react';
import IconButton from 'material-ui/IconButton';
import ContentUnit from 'material-ui/svg-icons/device/widgets';

/**
 * An icon button.
 */
class ProductUnitsStaticIconButton extends Component {
    render() {
        return (
            <IconButton style={{overflow: 'inherit'}}>
                <ContentUnit color="#262360"/>
            </IconButton>
        )
    }
}

export default ProductUnitsStaticIconButton;



// WEBPACK FOOTER //
// ./src/Fuse/buttons/ProductUnitsStaticIconButton.js